module.exports = __webpack_public_path__ + "static/media/9_5.943128bf.png";